import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { SupplierOtherCreditorProfile } from '@admin/supplier-other-creditor/models/supplier-other-creditor-profile';
import { IColumnDefinition } from '@common/models/column-definition';

@Component({
  selector: 'mojo-supplier-other-creditor-profile-table',
    templateUrl: './supplier-other-creditor-profile-table.component.html'
})
export class SupplierOtherCreditorProfileTableComponent implements OnInit {
  @ViewChild('dt', { static: true }) dt: Table;
    @Input() supplierOtherCreditorProfiles: SupplierOtherCreditorProfile[] = [];
  @Input() loading: boolean = false;

    @Output() onRowClicked = new EventEmitter<SupplierOtherCreditorProfile>();

    columns: Array<IColumnDefinition> = [
        { Header: 'Name', Field: 'name' },
        { Header: 'Type', Field: 'type' },
        { Header: 'Profile', Field: 'profile.name' },
        { Header: 'Category', Field: 'profile.type' }
    ];

  ngOnInit() {
    console.log(this.supplierOtherCreditorProfiles);
  }

    onRowSelect(data: SupplierOtherCreditorProfile) {
    this.onRowClicked.emit(data);
  }

   getGlobalFilterFields(): string[] {
    return this.columns.map(h => h.Field);
  }
}
